import script from "./CircleSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CircleSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./CircleSpinner.vue?vue&type=style&index=0&id=0a756be9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a756be9"]])

export default __exports__